(function () {
  function pruneCardPrices(root) {
    // retire les éléments qu’on ne veut JAMAIS sur les cartes
    root.querySelectorAll(
      '.lm-price--card .price__box-line, ' +
      '.lm-price--card [class*="price__box"], ' +
      '.lm-price--card [class*="unit-price"], ' +
      '.lm-price--card .price-badge'
    ).forEach(n => n.remove());
  }

  // 1) au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => pruneCardPrices(document));
  } else {
    pruneCardPrices(document);
  }

  // 2) si le thème réhydrate (sections, filtres, infinite scroll…)
  const mo = new MutationObserver(muts => {
    let touched = false;
    for (const m of muts) {
      if (m.type !== 'childList') continue;
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        const el = /** @type {Element} */ (n);
        if (
          el.matches?.('.lm-price--card, product-price, [data-price], .product-card, .grid')
          || el.querySelector?.('.lm-price--card, [data-price]')
        ) { touched = true; break; }
      }
      if (touched) break;
    }
    if (touched) pruneCardPrices(document);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 3) petits filets pour Shopify
  document.addEventListener('shopify:section:load', () => pruneCardPrices(document));
  document.addEventListener('shopify:section:unload', () => pruneCardPrices(document));
  window.addEventListener('load', () => pruneCardPrices(document));
})();
